import React, { useState, useRef, useLayoutEffect } from "react";
import { animateScroll as scroll } from "react-scroll";
import "./progress.css";
import { AiOutlineArrowUp } from "react-icons/ai";
import Navbar from "../../components/Navbar";
import Sidebar from "../../components/Sidebar";
import Hero from "../../components/HeroSection";
import InfoSection from "../../components/InfoSection";
import Services from "../../components/Services";
import Footer from "../../components/Footer";
import Head from "../../Page";
import {
  homeObjOne,
  homeObjTwo,
  homeObjThree,
  homeObjFour,
} from "../../components/InfoSection/Data";
import ProgressBar from "react-customizable-progressbar";

const Home = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };
  const [progress, setProgress] = useState(0);
  const contentRef = useRef();

  useLayoutEffect(() => {
    const updateHeight = () => {
      if (!contentRef.current) return;
      const { height } = contentRef.current.getBoundingClientRect();

      setProgress(window.scrollY / (height - window.innerHeight));
    };

    updateHeight();

    window.addEventListener("scroll", updateHeight);
    return () => {
      window.removeEventListener("scroll", updateHeight);
    };
  }, []);

  return (
    <div ref={contentRef}>
      <Head title="Acasa">
        <Sidebar isOpen={isOpen} toggle={toggle} />
        <ProgressBar
          radius={100}
          progress={Math.ceil(progress * 100)}
          strokeWidth={15}
          strokeColor="salmon"
          trackStrokeWidth={15}
          className="your-indicator"
          fillColor="#000"
        >
          {Math.ceil(progress * 100) === 99 ? (
            <div className="indicator-top">
              <AiOutlineArrowUp
                onClick={() => scroll.scrollToTop()}
                style={{
                  color: "white",
                  width: "30px",
                  height: "30px",
                  cursor: "pointer",
                }}
              />
            </div>
          ) : (
            <div className="indicator">
              <div>{Math.ceil(progress * 100)}%</div>
            </div>
          )}
        </ProgressBar>
        <Navbar toggle={toggle} isOpen={isOpen} />
        <Hero />
        <InfoSection {...homeObjOne} />
        <InfoSection {...homeObjTwo} />
        <Services />
        <InfoSection {...homeObjThree} />
        <InfoSection {...homeObjFour} />
        <Footer />
      </Head>
    </div>
  );
};

export default Home;
